import { dewiExpanded } from "@/app/fonts/fonts";
import React, {HTMLAttributes} from "react";
import {cn} from "@/lib/utils";

interface IProps extends HTMLAttributes<HTMLElement> {
    children: React.ReactNode;
}

export const AppTitle = ({ children, className, ...props }: IProps) => {
    return (
        <h1
            className={cn(
                dewiExpanded.className,
                "font-black text-[36px] leading-[99%] tracking-[-6%] text-white",
                className
            )}
            {...props}
        >
            {children}
        </h1>
    );
};
